"use client"

import { Component } from "react"
import { connect } from "react-redux"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import TitleBoxContent from "../../../components/pages/TitleContent"
import actionTypes from "../../../constants/actionTypes"

class ChurchNewsDetail extends Component {
    componentDidMount() {
        this.fetchNewsDetail()
    }

    componentDidUpdate(prevProps) {
        // 삭제 성공 시 목록으로 이동
        if (prevProps.board.delete.loading && !this.props.board.delete.loading && this.props.board.delete.success) {
            alert("게시글이 삭제되었습니다.")
            window.location.href = "/church-news"
        }

        // 삭제 실패 시 에러 메시지 표시
        if (prevProps.board.delete.loading && !this.props.board.delete.loading && this.props.board.delete.error) {
            alert(`삭제 실패: ${this.props.board.delete.error}`)
        }
    }

    fetchNewsDetail = () => {
        // URL에서 마지막 부분만 ID로 사용 (church-news/18)
        const pathParts = window.location.pathname.split("/")
        const id = pathParts[pathParts.length - 1]

        if (id && !isNaN(id) && id !== "undefined") {
            this.props.dispatch({
                type: actionTypes.BOARD_DETAIL_FETCH,
                payload: {
                    id: Number.parseInt(id),
                },
            })
        } else {
            this.props.dispatch({
                type: actionTypes.BOARD_DETAIL_FETCH_FAILED,
                payload: "유효하지 않은 게시글 ID입니다.",
            })
        }
    }

    hasAdminPermission = () => {
        const { loginData } = this.props

        if (!loginData) {
            return false
        }

        const { isLogin, role } = loginData

        if (!isLogin || !role) {
            return false
        }

        const adminRoles = ["ROLE_WEB_ADMIN", "ROLE_ADMIN"]
        const hasPermission = adminRoles.includes(role)

        return hasPermission
    }

    handleEdit = () => {
        const { detail } = this.props.board


        if (detail.data && detail.data.id) {
            // URL에서 추출한 ID 사용
            const pathParts = window.location.pathname.split("/")
            const urlId = pathParts[pathParts.length - 1]
            const editUrl = `/church-news/edit/${urlId}`
            window.location.href = editUrl
        } else {
            alert("게시글 정보를 찾을 수 없습니다.")
        }
    }

    handleDelete = () => {
        const { detail } = this.props.board

        // URL에서 실제 게시글 ID 추출
        const pathParts = window.location.pathname.split("/")
        const urlId = pathParts[pathParts.length - 1]


        if (!urlId || isNaN(urlId)) {
            alert("유효하지 않은 게시글 ID입니다.")
            return
        }

        if (window.confirm("정말로 이 게시글을 삭제하시겠습니까?")) {

            // URL에서 추출한 실제 게시글 ID를 boardId로 전달
            this.props.dispatch({
                type: actionTypes.BOARD_DELETE,
                payload: {
                    boardId: Number.parseInt(urlId), // URL의 실제 게시글 ID 사용
                },
            })
        } else {
        }
    }

    handleBack = () => {
        window.location.href = "/church-news"
    }

    formatDate = (dateString) => {
        if (!dateString) return ""
        const date = new Date(dateString)
        return date.toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
    }

    renderContent() {
        const { detail } = this.props.board

        if (detail.loading) {
            return (
                <div className="news-detail-loading">
                    <div className="loading-spinner"></div>
                    <p>게시글을 불러오는 중...</p>
                </div>
            )
        }

        if (detail.error) {
            return (
                <div className="news-detail-error">
                    <div className="error-icon">⚠️</div>
                    <p>{detail.error}</p>
                    <button className="btn btn-primary" onClick={this.handleBack}>
                        목록으로 돌아가기
                    </button>
                </div>
            )
        }

        if (!detail.data) {
            return (
                <div className="news-detail-error">
                    <div className="error-icon">📄</div>
                    <p>게시글을 찾을 수 없습니다.</p>
                    <button className="btn btn-primary" onClick={this.handleBack}>
                        목록으로 돌아가기
                    </button>
                </div>
            )
        }

        const newsItem = detail.data
        const hasPermission = this.hasAdminPermission()

        // URL에서 실제 게시글 ID 추출
        const pathParts = window.location.pathname.split("/")
        const urlId = pathParts[pathParts.length - 1]

        return (
            <div className="news-detail-container">
                <div className="news-detail-wrapper">
                    <div className="news-detail-header">
                        <div className="category-tag">공지사항</div>
                        <h1 className="news-detail-title">{newsItem.title}</h1>
                        <div className="news-detail-meta">
              <span className="author">
                <i className="fas fa-user"></i> {newsItem.memberName || newsItem.author || "관리자"}
              </span>
                            <span className="date">
                <i className="fas fa-calendar"></i> {this.formatDate(newsItem.createdAt || newsItem.createDate)}
              </span>
                            <span className="views">
                <i className="fas fa-eye"></i> {newsItem.viewCount || 0}
              </span>
                        </div>
                    </div>

                    <div className="news-detail-content">
                        <div className="content-body" dangerouslySetInnerHTML={{ __html: newsItem.contents || newsItem.content }} />
                    </div>

                    <div className="news-detail-actions">
                        <button className="btn btn-list" onClick={this.handleBack}>
                            목록
                        </button>
                        {hasPermission && (
                            <div className="action-group">
                                <button
                                    className="btn btn-edit"
                                    onClick={this.handleEdit}
                                    style={{
                                        marginLeft: "10px",
                                        backgroundColor: "#007bff",
                                        color: "white",
                                        padding: "8px 16px",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                >
                                    수정
                                </button>
                                <button
                                    className="btn btn-delete"
                                    onClick={this.handleDelete}
                                    style={{
                                        marginLeft: "10px",
                                        backgroundColor: "#dc3545",
                                        color: "white",
                                        padding: "8px 16px",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                >
                                    삭제
                                </button>
                            </div>
                        )}
                    </div>

                    {/* 디버깅용 정보 표시 */}
                    {process.env.NODE_ENV === "development" && (
                        <div
                            style={{
                                marginTop: "20px",
                                padding: "10px",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                            }}
                        >
                            <h4>디버깅 정보:</h4>
                            <p>권한 있음: {hasPermission ? "Yes" : "No"}</p>
                            <p>로그인 상태: {this.props.loginData?.isLogin ? "Yes" : "No"}</p>
                            <p>사용자 역할: {this.props.loginData?.role || "None"}</p>
                            <p>URL ID: {urlId}</p>
                            <p>Detail Data ID: {newsItem.id}</p>
                            <p>URL: {window.location.pathname}</p>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    renderMobileContent() {
        const { detail } = this.props.board

        if (detail.loading) {
            return (
                <div className="news-detail-loading mobile">
                    <div className="loading-spinner"></div>
                    <p>게시글을 불러오는 중...</p>
                </div>
            )
        }

        if (detail.error || !detail.data) {
            return (
                <div className="news-detail-error mobile">
                    <div className="error-icon">⚠️</div>
                    <p>{detail.error || "게시글을 찾을 수 없습니다."}</p>
                    <button className="btn btn-primary mobile-btn" onClick={this.handleBack}>
                        목록으로 돌아가기
                    </button>
                </div>
            )
        }

        const newsItem = detail.data
        const hasPermission = this.hasAdminPermission()

        return (
            <div className="news-detail-container mobile">
                <div className="news-detail-wrapper">
                    <div className="news-detail-header">
                        <div className="category-tag">공지사항</div>
                        <h1 className="news-detail-title">{newsItem.title}</h1>
                        <div className="news-detail-meta mobile-meta">
                            <div className="meta-row">
                <span className="author">
                  <i className="fas fa-user"></i> {newsItem.memberName || newsItem.author || "관리자"}
                </span>
                                <span className="views">
                  <i className="fas fa-eye"></i> {newsItem.viewCount || 0}
                </span>
                            </div>
                            <div className="meta-row">
                <span className="date">
                  <i className="fas fa-calendar"></i> {this.formatDate(newsItem.createdAt || newsItem.createDate)}
                </span>
                            </div>
                        </div>
                    </div>

                    <div className="news-detail-content">
                        <div
                            className="content-body mobile-content"
                            dangerouslySetInnerHTML={{ __html: newsItem.contents || newsItem.content }}
                        />
                    </div>

                    <div className="news-detail-actions mobile-actions">
                        <button className="btn btn-list mobile-btn" onClick={this.handleBack}>
                            목록
                        </button>
                        {hasPermission && (
                            <div className="action-group mobile-action-group">
                                <button
                                    className="btn btn-edit mobile-btn"
                                    onClick={this.handleEdit}
                                    style={{
                                        backgroundColor: "#007bff",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        margin: "5px",
                                    }}
                                >
                                    수정
                                </button>
                                <button
                                    className="btn btn-delete mobile-btn"
                                    onClick={this.handleDelete}
                                    style={{
                                        backgroundColor: "#dc3545",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                >
                                    삭제
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <section className="pf-page">
                <PC>
                    <div className="background">
                        <div className="layout">
                            {this.renderContent()}
                        </div>
                    </div>
                </PC>

                <Notebook>
                    <div className="background">
                        <div className="layout">
                            {this.renderContent()}
                        </div>
                    </div>
                </Notebook>

                <Tablet>
                    <div className="background">
                        <div className="layout">
                            {this.renderContent()}
                        </div>
                    </div>
                </Tablet>

                <Mobile>
                    <div className="background">
                        <div className="layout">
                            {this.renderMobileContent()}
                        </div>
                    </div>
                </Mobile>
            </section>
        )
    }
}

const mapStateToProps = (state) => ({
    board: state.board,
    loginData: state.login,
})

export default connect(mapStateToProps)(ChurchNewsDetail)
